const findAllReferences = (parentElement, associatedDictionary) => {
  for (const key in parentElement) {
    let foiFound;
    let fliFound;
    let element = parentElement[key];
    if (Array.isArray(element)) {
      for (let entry of element) {
        if (typeof (entry) != "object" || Array.isArray(entry)) {
          break;
        } else {
          findAllReferences({ [key]: entry }, associatedDictionary);
        }
      }
    } else if (element && (typeof (element.reference) === "string" || element.identifier?.system === "https://fevir.net/FLI" || (element.identifier?.type?.text && JSON.stringify(element.identifier.type.text).includes("FEvIR Linking Identifier")))) {
      let resourceType = element.type;
      if (typeof (element.reference) === "string" && element.reference.split("/").length === 2 && !isNaN(element.reference.split("/")[1])) {
        foiFound = element.reference.split("/")[1];
        if (!resourceType) {
          resourceType = element.reference.split("/")[0];
        }
      } else if (element.identifier?.system === "https://fevir.net/FLI" ||
        (element.identifier?.type?.text && JSON.stringify(element.identifier.type.text).includes("FEvIR Linking Identifier"))) {
        fliFound = element.identifier.value;
      }
      if (foiFound || fliFound) {
        let title = element.display;
        if (!title) {
          title = "[Title not captured] " + (foiFound || fliFound);
        }
        let url;
        if (foiFound) {
          url = "/resources/" + resourceType + "/" + foiFound;
        } else {
          url = "/FLI/" + fliFound;
        }
        if (!resourceType) {
          resourceType = "UNKNOWN";
        }
        if (!associatedDictionary[resourceType]) {
          associatedDictionary[resourceType] = [];
        }
        associatedDictionary[resourceType].push({ "title": title, "url": url, "foi": foiFound, "fli": fliFound });
      }
    } else if (typeof (element) === "object") {
      findAllReferences(element, associatedDictionary);
    }
  }
  return associatedDictionary;
}

const getAssociatedResourcesDictionary = (fhirJson) => {
    if (typeof (fhirJson) === "object") {
      let associatedResourcesDictionary = {};
      findAllReferences(fhirJson, associatedResourcesDictionary);
      for (const resourceType in associatedResourcesDictionary) {
        let entries = associatedResourcesDictionary[resourceType];
        entries.sort((a, b) => a.title.toLowerCase() < b.title.toLowerCase() ? 1 : -1);
      }
      return associatedResourcesDictionary;
    }
}

//associatedDictionary[resourceType].push({ "title": string, "url": string, "foi": string, "fli": string });
export { getAssociatedResourcesDictionary };